<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand"
    :class="{ 'bg-blue navbar-dark': type === 'default' }"
  >
    <!-- Search form -->
    <!-- FUTURE: un-hide this -->
    <!-- <b-form
      class="navbar-search form-inline mr-sm-3"
      :class="{
        'navbar-search-light': type === 'default',
        'navbar-search-dark': type === 'light'
      }"
      id="navbar-search-main"
    >
      <b-form-group class="mb-0">
        <b-input-group class="input-group-alternative input-group-merge">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <i class="fas fa-search"></i>
            </span>
          </div>
          <b-form-input placeholder="Search" type="text"></b-form-input>
        </b-input-group>
      </b-form-group>
      <button
        type="button"
        class="close"
        data-action="search-close"
        data-target="#navbar-search-main"
        aria-label="Close"
      >
        <span aria-hidden="true">×</span>
      </button>
    </b-form>-->
    <!-- Navbar links -->
    <b-navbar-nav class="align-items-center ml-md-auto">
      <!-- This item dont have <b-nav-item> because they add class 'nav-link' which is not needed here -->
      <li class="nav-item d-xl-none">
        <div
          class="pr-3 sidenav-toggler"
          :class="{
            active: $sidebar.showSidebar,
            'sidenav-toggler-dark': type === 'default',
            'sidenav-toggler-light': type === 'light',
          }"
          @click="toggleSidebar"
        >
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>
      <!-- This item dont have <b-nav-item> because item have data-action/data-target on tag <a>, wich we cant add -->
      <li class="nav-item d-sm-none">
        <a
          class="nav-link"
          href="#"
          data-action="search-show"
          data-target="#navbar-search-main"
        >
          <i class="ni ni-zoom-split-in"></i>
        </a>
      </li>
      <!-- FUTURE: un-hide this -->
      <!-- <base-dropdown
        class="nav-item"
        tag="li"
        title-classes="nav-link"
        title-tag="a"
        icon="ni ni-bell-55"
        menu-classes="dropdown-menu-xl dropdown-menu-right py-0 overflow-hidden"
      >
        <template>
          <div class="px-3 py-3">
            <h6 class="text-sm text-muted m-0">
              You have
              <strong class="text-primary">13</strong> notifications.
            </h6>
          </div>
          
          <b-list-group flush>
            <b-list-group-item action href="#!">
              <b-row align-v="center">
                <b-col md="auto">
                  
                  <b-img
                    alt="Image placeholder"
                    src="img/theme/team-1.jpg"
                    class="avatar"
                    rounded="circle"
                  />
                </b-col>
                <b-col class="ml--2">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <h4 class="mb-0 text-sm">John Snow</h4>
                    </div>
                    <div class="text-right text-muted">
                      <small>2 hrs ago</small>
                    </div>
                  </div>
                  <p class="text-sm mb-0">
                    Let's meet at Starbucks at 11:30. Wdyt?
                  </p>
                </b-col>
              </b-row>
            </b-list-group-item>
            <a href="#!" class="list-group-item list-group-item-action">
              <b-row align-v="center">
                <b-col md="auto">
                  
                  <b-img
                    alt="Image placeholder"
                    src="img/theme/team-2.jpg"
                    class="avatar"
                    rounded="circle"
                  />
                </b-col>
                <b-col class="ml--2">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <h4 class="mb-0 text-sm">John Snow</h4>
                    </div>
                    <div class="text-right text-muted">
                      <small>3 hrs ago</small>
                    </div>
                  </div>
                  <p class="text-sm mb-0">
                    A new issue has been reported for Argon.
                  </p>
                </b-col>
              </b-row>
            </a>
            <b-list-group-item action href="#!">
              <b-row align-v="center">
                <b-col md="auto">
                  
                  <b-img
                    alt="Image placeholder"
                    src="img/theme/team-3.jpg"
                    class="avatar"
                    rounded="circle"
                  />
                </b-col>
                <b-col class="ml--2">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <h4 class="mb-0 text-sm">John Snow</h4>
                    </div>
                    <div class="text-right text-muted">
                      <small>5 hrs ago</small>
                    </div>
                  </div>
                  <p class="text-sm mb-0">Your posts have been liked a lot.</p>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item action href="#!">
              <b-row align-v="center">
                <b-col md="auto">
                  
                  <b-img
                    alt="Image placeholder"
                    src="img/theme/team-4.jpg"
                    class="avatar"
                    rounded="circle"
                  />
                </b-col>
                <b-col class="ml--2">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <h4 class="mb-0 text-sm">John Snow</h4>
                    </div>
                    <div class="text-right text-muted">
                      <small>2 hrs ago</small>
                    </div>
                  </div>
                  <p class="text-sm mb-0">
                    Let's meet at Starbucks at 11:30. Wdyt?
                  </p>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item action href="#!">
              <b-row align-v="center">
                <b-col md="auto">
                  
                  <b-img
                    alt="Image placeholder"
                    src="img/theme/team-5.jpg"
                    class="avatar"
                    rounded="circle"
                  />
                </b-col>
                <b-col class="ml--2">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <h4 class="mb-0 text-sm">John Snow</h4>
                    </div>
                    <div class="text-right text-muted">
                      <small>3 hrs ago</small>
                    </div>
                  </div>
                  <p class="text-sm mb-0">
                    A new issue has been reported for Argon.
                  </p>
                </b-col>
              </b-row>
            </b-list-group-item>
          </b-list-group>
          <a
            href="#!"
            class="dropdown-item text-center text-primary font-weight-bold py-3"
            >View all</a
          >
        </template>
      </base-dropdown>-->

      <!-- FUTURE: un-hide this -->
      <!-- <base-dropdown
        menu-classes="dropdown-menu-lg dropdown-menu-dark bg-default dropdown-menu-right"
        class="nav-item"
        tag="li"
        title-tag="a"
        title-classes="nav-link"
        icon="ni ni-ungroup"
      >
        <template>
          <b-row class="shortcuts px-4">
            <a href="#!" class="col-4 shortcut-item">
              <span class="shortcut-media avatar rounded-circle bg-gradient-red">
                <i class="ni ni-calendar-grid-58"></i>
              </span>
              <small>Calendar</small>
            </a>
            <a href="#!" class="col-4 shortcut-item">
              <span class="shortcut-media avatar rounded-circle bg-gradient-orange">
                <i class="ni ni-email-83"></i>
              </span>
              <small>Email</small>
            </a>
            <a href="#!" class="col-4 shortcut-item">
              <span class="shortcut-media avatar rounded-circle bg-gradient-info">
                <i class="ni ni-credit-card"></i>
              </span>
              <small>Payments</small>
            </a>
            <a href="#!" class="col-4 shortcut-item">
              <span class="shortcut-media avatar rounded-circle bg-gradient-green">
                <i class="ni ni-books"></i>
              </span>
              <small>Reports</small>
            </a>
            <a href="#!" class="col-4 shortcut-item">
              <span class="shortcut-media avatar rounded-circle bg-gradient-purple">
                <i class="ni ni-pin-3"></i>
              </span>
              <small>Maps</small>
            </a>
            <a href="#!" class="col-4 shortcut-item">
              <span class="shortcut-media avatar rounded-circle bg-gradient-yellow">
                <i class="ni ni-basket"></i>
              </span>
              <small>Shop</small>
            </a>
          </b-row>
        </template>
      </base-dropdown>-->
    </b-navbar-nav>
    <b-navbar-nav class="align-items-center ml-auto ml-md-0">
      <base-dropdown
        menu-on-right
        class="nav-item"
        tag="li"
        title-tag="a"
        menu-classes="dropdown-menu-right pr-0"
      >
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <b-media no-body class="align-items-center">
            <span class="avatar avatar-sm rounded-circle">
              <img v-if="user" alt="Image placeholder" :src="user.avatarUrl" />
            </span>
            <b-media-body class="ml-2 d-none d-lg-block">
              <span v-if="user" class="mb-0 text-sm font-weight-bold">
                {{ user.displayName }}
              </span>
            </b-media-body>
          </b-media>
        </a>

        <template>
          <b-dropdown-header class="noti-title">
            <h6 class="text-overflow m-0">Account menu</h6>
          </b-dropdown-header>
          <b-dropdown-item to="/user">
            <i class="ni ni-single-02"></i>
            <span>My profile</span>
          </b-dropdown-item>
          <b-dropdown-item to="/select-account">
            <i class="fa fa-random"></i>
            <span>Switch account</span>
          </b-dropdown-item>
          <div class="dropdown-divider"></div>
          <b-dropdown-item href="#!" @click="logout">
            <i class="ni ni-user-run"></i>
            <span>Logout</span>
          </b-dropdown-item>
        </template>
      </base-dropdown>
    </b-navbar-nav>
  </base-nav>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { BaseNav, Modal } from "@/components";

export default {
  components: {
    CollapseTransition,
    BaseNav,
    Modal,
  },
  props: {
    type: {
      type: String,
      default: "default", // default|light
      description:
        "Look of the dashboard navbar. Default (Green) or light (gray)",
    },
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    user() {
      return this.$auth.user();
    },
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: "",
    };
  },
  methods: {
    logout() {
      this.$auth
        .logout()
        .then(() => {
          // clear any local storage
          this.$ls.clear();
          // clear from store
          this.$store.commit("SET_ACCOUNT", null);
          this.$store.commit("SET_MEMBERSHIP", null);
        })
        .catch((err) => {
          console.error("Error after logout(): ", err);
        });
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
  },
};
</script>
